import React, { useState, useContext } from 'react'
// import styled from 'styled-components'
// import LanguageContext from './LanguageContext.js'
import { languageOptions } from './languages/index.js';
import { LanguageContext } from './LanguageContext.js';


export default function LanguageSelector() {
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);

  // set selected language by calling context method
  const handleLanguageChange = e => userLanguageChange(e.target.value);

  return (
    <select
      onChange={handleLanguageChange}
      value={userLanguage}
    >
      {Object.entries(languageOptions).map(([id, name]) => (
        <option key={id} value={id}>{name}</option>
      ))}
    </select>
  );
};
export const LanguageButton = () => {
    const [isClicked, setIsClicked] = useState(false)
    // const {language, setLanguage} = useContext(LanguageContext)

    // const changeLanguage = () => {
    //     setIsClicked(!isClicked)
    // }

    const { userLanguage, userLanguageChange } = useContext(LanguageContext);

    // set selected language by calling context method
    const handleLanguageChange = e => userLanguageChange(e.target.value);

    return (
        <span>
            {/* <Span> */}
                <button style={{ padding: 0 }} onClick={handleLanguageChange}>
                    Language - {userLanguage}
                </button>
            {/* </Span> */}
            {isClicked ?
                <div style={{ position: 'absolute' }}>
                    <div><button onClick={() => userLanguageChange('PT')} >PT - Portuguese</button></div>
                    <div><button onClick={() => userLanguageChange('EN')}>EN - English</button></div>
                </div> : ''
            }
        </span>
    )
}

